var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "历史调价记录",
        visible: _vm._dialogVisible,
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm._dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        [
          _c(
            "el-form-item",
            { attrs: { label: "商品信息" } },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.goodsData, border: "" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "goodCategoryName",
                      align: "center",
                      label: "分类名称",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "picture", align: "center", label: "图片" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticClass: "wrap-picture-style" }, [
                              _c("img", {
                                staticStyle: {
                                  width: "120px",
                                  height: "120px",
                                },
                                attrs: { src: scope.row.picture, alt: "" },
                              }),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "title",
                      align: "center",
                      label: "菜品名称",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "goodSpecName",
                      align: "center",
                      label: "规格(g)",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pieceUnit",
                      align: "center",
                      label: "计价方式",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.pieceUnit === 0
                              ? _c("span", [_vm._v("计重")])
                              : _vm._e(),
                            scope.row.pieceUnit === 1
                              ? _c("span", [_vm._v("计件")])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "调价历史记录" } },
            [
              _c(
                "hx-table-result",
                {
                  attrs: { "page-info": _vm.pager },
                  on: {
                    "page-current-change": _vm.handleCurrentChange,
                    "page-size-change": _vm.handleSizeChange,
                  },
                },
                [
                  _c(
                    "el-table",
                    {
                      ref: "table",
                      attrs: {
                        slot: "content",
                        data: _vm.tableData,
                        "max-height": "800",
                        border: "",
                      },
                      slot: "content",
                    },
                    [
                      _c("el-table-column", {
                        attrs: { align: "center", width: "60", label: "序号" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      (_vm.pager.pageIndex > 1
                                        ? (_vm.pager.pageIndex - 1) *
                                          _vm.pager.pageSize
                                        : 0) +
                                        scope.$index +
                                        1
                                    ),
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "createDate",
                          align: "center",
                          label: "调价时间",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("formatDate")(row.createDate, true)
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "operator",
                          align: "center",
                          label: "操作者",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "beforeData",
                          align: "center",
                          label: "调价前单价",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c("p", [
                                  _vm._v(
                                    "商品价格：" + _vm._s(row.beforeData.price)
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "afterPrice",
                          align: "center",
                          label: "调价后单价",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c("p", [
                                  _vm._v(
                                    "商品价格：" + _vm._s(row.afterData.price)
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }